import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=3967830e&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=3967830e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967830e",
  null
  
)

export default component.exports